import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styles from "./Home.module.css";
import Carousel from "../../components/сarousel/Carousel";
import { Stub } from "../../components/stub/Stub";
import { postEvents, postSubmitApplication } from "./api";
import { formatDateRange } from "../../components/auxiliaryFunctions";
import { ModalInfoProfile, ModalEventApplication } from "../../components/modalInfo/ModalInfo";
import { SkeletonCard } from "../../components/skeleton/card/SkeletonCard";
import { useScreenSize } from "../../components/auxiliaryFunctions";

import { useApi } from '../../utils/useApi';
import { createAuthApi } from './api';

const Home = ({ isToken }) => {
    const navigate = useNavigate();
    const { isMobile } = useScreenSize();
    const { customFetch } = useApi();
    const authApi = createAuthApi(customFetch);

    const [isProfileFilled, setIsProfileFilled] = useState(true);
    const [events, setEvents] = useState([]);
    const [infoModal, setInfoModal] = useState(false);
    const [isModelOpen, setIsModelOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(true);


    function delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    const openModel = (event_id) => {
        const foundEvent = events.find(event => event.id === event_id);
        navigate(`/apply/${event_id}`, { state: foundEvent });
    }

    const getEvents = async () => {
        setIsLoading(true);
        try {
            const result = await authApi.postEvents();
            await delay(300)
            if (result) {
                setIsProfileFilled(result.isProfileFilled);
                setInfoModal(!result.isProfileFilled);
                setEvents(result.nextEvents);
            }
        } catch (error) {
            console.error('Events failed:', error);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (isToken) {
            getEvents();
        } else {
            setIsLoading(false);
        }
    }, [isToken]);

    return (
        <main className={styles.mainContent}>
            {!isMobile && (
                <div className={styles.headerBox}>
                    <h1 className={styles.title}>Ближайшие события</h1>

                    {(!isProfileFilled && !isMobile) && (
                        <div className={styles.profileAlert}>
                            <p>Подача заявок станет</p>
                            <p>доступна после</p>
                            <p>заполнения <Link to="/edit-profile" className={styles.profileLink}>профиля</Link></p>
                        </div>
                    )}
                </div>
            )}


            <div className={styles.eventsContainer}>
                {isLoading ? (
                    <SkeletonCard count={isMobile ? 1 : 3} />
                ) : events.length === 0 ? (
                    <Stub />
                ) : (
                    <Carousel events={events} isProfileFilled={isProfileFilled} Card={EventCard} openModel={openModel} isMobile={isMobile} />
                )}
            </div>

            {infoModal && (
                <ModalInfoProfile isModalOpen={infoModal} setIsModalOpen={setInfoModal} />
            )}
            {isModelOpen && (
                <ModalEventApplication isModalOpen={isModelOpen} setIsModalOpen={setIsModelOpen} />
            )}
        </main>
    );
};

// EventCard остается без изменений
// EventCard компонент с улучшенной версткой для текста
const EventCard = ({ event, isProfileFilled, openModel }) => {
    const renderButton = () => {
        if (isProfileFilled) {
            if (event.isApplicationSubmitted) {
                return <div className={styles.statusTextExpectation}>Ваша заявка отправлена, ждите изменения статуса в моих заявках</div>;
            }
            if (!event.allowRegistration) {
                return <div className={styles.statusText}>РЕГИСТРАЦИЯ ЗАКРЫТА</div>;
            }    
            if (event.allowRegistration) {
                return <button className={styles.applyButton} onClick={() => openModel(event.id)}>ПОДАТЬ ЗАЯВКУ</button>;
            }
            if (event?.isRegistrationClosed) {
                return <div className={styles.statusText}>РЕГИСТРАЦИЯ ЗАКРЫТА</div>;
            } 
            return null;
        }
    };

    return (
        <div className={styles.card}>
            <div className={styles.header}>
                <div className={styles.dateLocation}>
                    <div className={styles.date}>{formatDateRange(event.beginDate, event.endDate)}</div>
                    <div className={styles.location}>{event.city}</div>
                </div>
            </div>

            <div className={styles.content}>
                <h3 className={styles.eventTitle}>{event.name}</h3>
                {event.description && (
                    <p className={styles.eventDescription}>{event.description}</p>
                )}
            </div>

            <div className={styles.actions}>
                <a
                    href={event.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.detailsButtonLink}
                >
                    О СОБЫТИИ
                </a>
                {renderButton()}
            </div>
        </div>
    );
};

export default Home;